import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './styles/globals.css'
import { captureMetaClickIds } from './utils/metaClickIds'

// Ads land on https://wallet.mymoolah.africa/?fbclid=... The root route then
// redirects inside the app and drops the query string. Save fbc before React
// navigates. Later routes read the cookie and localStorage.
captureMetaClickIds(window.location.search)

// Conditionally load manifest.json only when not in Codespaces/github.dev
// GitHub Codespaces intercepts manifest.json requests and redirects them through
// their auth proxy, causing CORS errors. This dynamic loading prevents the error.
if (!window.location.hostname.includes('github.dev') && !window.location.hostname.includes('codespaces')) {
  // Check if manifest link already exists
  if (!document.querySelector('link[rel="manifest"]')) {
    const link = document.createElement('link');
    link.rel = 'manifest';
    link.href = '/manifest.json';
    document.head.appendChild(link);
  }
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)